<div class="bg-lBlack light:bg-lGray950 border border-lGray800 rounded-2xl p-5 h-full min-h-[11.5rem] flex flex-col">
  <div class="flex items-center gap-3">
    <span class="w-9 h-9 rounded-xl bg-lGray700 flex items-center justify-center shrink-0">
      <l-icon class="text-lWhite text-lg leading-none">{{ metric.icon }}</l-icon>
    </span>
    <p class="text-color text-base font-semibold">{{ metric.title }}</p>
  </div>

  <div class="flex flex-col items-center justify-center flex-1 text-center">
    <p class="text-color text-5xl font-bold leading-none">{{ metric.value }}</p>
    <p class="subtext-color text-base mt-3">{{ metric.trendLabel }}</p>
  </div>
</div>
